/** The texts of study tags (LBL-10) and of the AO classification's reading of codes (LBL-11), spread into the app's dictionaries (`lib/i18n.tsx`). */
export const studyTagsEn = {
  studyTagSame: 'The same answer on all {count} views of the study',
  studyTagDiffers: 'Other views of the study have another answer.',
  studyTagElsewhere: 'Other views of the study have {answer}, this one not.',
  setHereToo: 'Set it here too',
  aoUnread: '“{code}” is no PCCF or AO/OTA code.',
  aoUseCode: 'Use {code}',
  aoAddition: '“{addition}” is not part of the notation.',
  aoAgreement: 'AO classification by level',
  aoAgreementHelp: 'Among the studies either reader classified, the share on which both name the same codes at each level; a code for both bones of a pair counts as the codes of each.',
  aoClassified: 'Studies classified',
  aoLevel_segment: 'Bone and segment',
  aoLevel_zone: 'Epiphysis, metaphysis or diaphysis',
  aoLevel_pattern: 'Child code',
  aoLevel_severity: 'Severity',
}

export const studyTagsDe: Record<keyof typeof studyTagsEn, string> = {
  studyTagSame: 'Dieselbe Antwort auf allen {count} Ansichten der Studie',
  studyTagDiffers: 'Andere Ansichten der Studie haben eine andere Antwort.',
  studyTagElsewhere: 'Andere Ansichten der Studie haben {answer}, diese nicht.',
  setHereToo: 'Auch hier setzen',
  aoUnread: '„{code}“ ist kein PCCF- oder AO/OTA-Code.',
  aoUseCode: '{code} verwenden',
  aoAddition: '„{addition}“ gehört nicht zur Notation.',
  aoAgreement: 'AO-Klassifikation nach Ebene',
  aoAgreementHelp: 'Unter den Studien, die einer der beiden klassifiziert hat, der Anteil, auf dem beide auf jeder Ebene dieselben Codes nennen; ein Code für beide Knochen eines Paares zählt als die Codes jedes Knochens.',
  aoClassified: 'Klassifizierte Studien',
  aoLevel_segment: 'Knochen und Segment',
  aoLevel_zone: 'Epiphyse, Metaphyse oder Diaphyse',
  aoLevel_pattern: 'Kindercode',
  aoLevel_severity: 'Schweregrad',
}
